import { render } from "./InputHead.vue?vue&type=template&id=daf26aac&scoped=true"
import script from "./InputHead.vue?vue&type=script&lang=js"
export * from "./InputHead.vue?vue&type=script&lang=js"

import "./InputHead.vue?vue&type=style&index=0&id=daf26aac&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf26aac"]])

export default __exports__